<template>
    <main class="-mt-32">
        <div class="px-4 py-10 pb-12 mx-auto -mt-32 max-w-7xl sm:px-6 lg:px-8">
            <div class="overflow-hidden bg-white shadow sm:rounded-md">
                <div class="px-4 py-4 sm:px-6">
                    <div class="flex rounded-md shadow-sm">
                        <div class="relative flex-grow focus-within:z-10">
                            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    class="w-5 h-5 text-gray-400"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                                </svg>
                            </div>
                            <input
                                v-model="query"
                                class="block w-full pl-10 transition duration-150 ease-in-out rounded-none form-input rounded-l-md sm:text-sm sm:leading-5"
                            />
                        </div>
                        <router-link
                            tag="button"
                            :to="`/patients/new`"
                            class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-r-md hover:bg-indigo-500 focus:outline-none"
                        >
                            <svg
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                class="w-5 h-5"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            <span class="ml-2">Paziente</span>
                        </router-link>
                    </div>
                </div>
                <div class="main-container">
                    <ul
                        v-if="filtered.length"
                        class="scrollable"
                        @scroll="scroll"
                    >
                        <li
                            v-for="patient in filtered"
                            :key="patient.id"
                            class="border-t border-gray-200"
                        >
                            <router-link
                                :to="`/patients/${patient.id}`"
                                class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
                            >
                                <div class="flex items-center px-4 py-4 sm:px-6">
                                    <div class="flex items-center flex-1 min-w-0">
                                        <div class="flex-1 min-w-0 px-4 md:grid md:grid-cols-2 md:gap-4">
                                            <div>
                                                <div class="text-sm font-medium leading-5 text-indigo-600 truncate">
                                                    {{ patient.full_name }}
                                                </div>
                                                <patient-email
                                                    v-if="patient.email"
                                                    :email="patient.email"
                                                />
                                                <patient-phone
                                                    v-if="patient.phone"
                                                    :phone="patient.phone"
                                                />
                                                <patient-mobile
                                                    v-if="patient.mobile"
                                                    :mobile="patient.mobile"
                                                />
                                            </div>
                                            <div class="hidden md:block">
                                                <div>
                                                    <div class="text-sm leading-5 text-gray-900">
                                                        <span v-if="patient.vat">
                                                            PIVA {{ patient.vat }}
                                                        </span>
                                                        <span v-if="patient.fiscal_cod">
                                                            CF {{ patient.fiscal_code }}
                                                        </span>
                                                    </div>
                                                    <div class="flex items-center mt-2 text-sm leading-5 text-gray-500">
                                                        {{ patient.address}} {{ patient.zip }} {{ patient.city}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <svg
                                            class="w-5 h-5 text-gray-400"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapState } from "vuex";
import PatientEmail from "./PatientEmail";
import PatientPhone from "./PatientPhone";
import PatientMobile from "./PatientMobile";

export default {
    props: {
        history: {
            required: false
        }
    },

    data: () => {
        return {
            loaded: false,
            query: "",
            elements: 0,
            pagination: 50,
            page: 1
        };
    },

    components: {
        PatientEmail,
        PatientPhone,
        PatientMobile
    },

    computed: {
        ...mapState("patient", ["patients"]),
        filtered() {
            this.loaded;
            let patients = !this.query
                ? Object.values(this.patients)
                : _.filter(this.patients, patient =>
                      patient.full_name
                          .toLowerCase()
                          .includes(this.query.toLowerCase())
                  );
            return patients
                .sort((a, b) => {
                    return a.last_name.toUpperCase() > b.last_name.toUpperCase()
                        ? 1
                        : b.last_name.toUpperCase() > a.last_name.toUpperCase()
                        ? -1
                        : 0;
                })
                .slice(0, this.page * this.pagination);
        }
    },

    methods: {
        scroll() {
            let container = $(".scrollable");
            let height = container.scrollHeight - container.offsetHeight;
            let scrollTop = container.scrollTop;
            if (
                this.page * this.pagination < this.elements &&
                height - scrollTop < container.offsetHeight
            ) {
                this.page++;
            }
        }
    },

    async mounted() {
        await this.$store.dispatch("patient/PATIENTS");
        this.elements = Object.keys(this.patients).length;
        this.loaded = true;
    }
};
</script>
